import {SmartComponent} from "smart-component-js";

class CarouselComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        super(element, parentComponent, params);
        this.element = element;

        this.isRtl = KD_COMMON_CONSTANTS.IS_RTL;

        this.carouselConfig = {
            margin: 98,
            stagePadding: 1,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1.5,
                    margin: 40
                },
                768: {
                    items: 2,
                    margin: 98
                },
                1280: {
                    items: 2,
                    margin: 98
                },
                1440: {
                    items: 3,
                    margin: 98
                }
            }
        };

        this.init();
    }

    init() {
        this.initCarousel('grey', 'gray');
        this.initCarousel('dark', 'white');
        this.initCarousel('light', 'gray');
    }

    initCarousel(theme, arrowColor) {
        const $carousel = $(`.${theme} .owl-carousel`);

        if (!$carousel.length) return;

        $carousel.owlCarousel({
            ...this.carouselConfig,
            rtl: this.isRtl,
            loop: $carousel.find('.card__image img').length > 3,
            navText: [
                `<span class="am-prev">
                <img src="/fe-web/img/marangoni/icons/long-arrow-left-${arrowColor}.svg" />
            </span>`,
                `<span class="am-next">
                <img src="/fe-web/img/marangoni/icons/long-arrow-right-${arrowColor}.svg" />
            </span>`
            ]
        });
    }
}

export default CarouselComponent;